<template>
  <v-row justify="center">
    <v-dialog persistent v-model="show">
      <v-row justify="center">
        <v-col cols="9" style="">
          <div
            id="receiptData"
            style="
              background: white;
              max-width: 800px;
              padding: 7px;
              margin-left: 28%;
            "
          >
            <body>
              <div id="page-wrap">
                <v-row
                  ><!-- top image -->
                  <v-col
                    cols="2"
                    lg="2"
                    xl="2"
                    md="2"
                    style="margin-left: 3%; margin-top: 0%"
                  >
                    <img
                      v-if="!imagelink"
                      style="height: 150px; width: 150px"
                      src="../../assets/img/nallai_logo.png"
                    />
                    <img
                      v-if="imagelink"
                      style="height: 150px; width: 150px"
                      :src="imagelink"
                    />
                  </v-col>
                  <!-- <v-col cols="4" lg="4" xl="4" md="4" style="margin-left:1%;"> 
                    <p
                      style="font-size:16px;
                    margin-top: 28%;"
                    >
                      <strong> Status : {{ PurchaseDetails.status }} </strong>
                    </p>
                  </v-col> -->

                  <!-- Warehouse Component -->
                  <v-col
                    cols="5"
                    xl="5"
                    md="5"
                    lg="5"
                    style="margin-left: 4%; margin-top: 1%"
                  >
                    <p style="color: black; font-size: 13px">To Warehouse:</p>
                    <b
                      v-if="PurchaseDetails && PurchaseDetails.warehouse"
                      style="color: black; font-size: 17px"
                    >
                      {{
                        PurchaseDetails.warehouse.name
                          ? PurchaseDetails.warehouse.name
                          : 'Warehouse'
                      }}</b
                    ><br />

                    <span style="color: black; font-size: 14px">
                      <strong>Address : </strong>
                      {{
                        PurchaseDetails.warehouse.address
                          ? PurchaseDetails.warehouse.address
                          : ''
                      }},
                      <br />
                      <strong> Phone No : </strong>
                      {{
                        PurchaseDetails.warehouse.phone
                          ? PurchaseDetails.warehouse.phone
                          : ''
                      }}.
                      <br />
                      <strong>Date : </strong>
                      {{ new Date().toLocaleString() }}.
                    </span>
                  </v-col>
                  <!-- Supplier component -->
                  <v-col
                    style="margin-left: 0%; margin-top: 1%"
                    cols="4"
                    xl="4"
                    md="4"
                    lg="4"
                  >
                    <p style="color: black; font-size: 13px">From Supplier:</p>
                    <b
                      style="color: black; font-size: 17px"
                      v-if="Suppliers.contact.length != 0"
                    >
                      {{
                        Suppliers.contact[0].full_name
                          ? Suppliers.contact[0].full_name
                          : 'Supplier Name'
                      }}
                    </b>
                    <br />
                    <span style="color: black; font-size: 14px">
                      <strong>Address : </strong>
                      {{
                        Suppliers.addresses[0].address_line1
                          ? Suppliers.addresses[0].address_line1
                          : '-----'
                      }}, {{ Suppliers.addresses[0].city }},
                      {{ Suppliers.addresses[0].postal_code }}.
                      <br />
                      <strong> Invoice No : </strong>
                      {{
                        PurchaseDetails.referenceNumber
                          ? PurchaseDetails.referenceNumber
                          : '-----'
                      }}
                      <br />
                      <strong>Date : </strong>
                      {{
                        PurchaseDetails.date
                          ? new Date(PurchaseDetails.date).toLocaleString()
                          : '-----'
                      }}
                    </span>
                  </v-col>
                </v-row>

                <!-- Products Table -->
                <table class="table products" style="margin-top: 4%">
                  <thead>
                    <tr>
                      <th class="products" colspan="9" style="color: black">
                        <b>Products</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="tablehead" style="font-weight: bold">
                      <td class="pl-2">Product</td>
                      <td>Batch</td>
                      <td>Unit</td>
                      <td style="text-align: center">Qty</td>
                      <td style="text-align: center">Damaged</td>
                      <td style="text-align: right">Price</td>
                      <td style="text-align: right">Total</td>
                      <td style="text-align: right">Discount</td>
                      <td class="pr-2" style="text-align: right">SubTotal</td>
                    </tr>
                    <tr v-for="(item, index) in ProductData" :key="index">
                      <td class="pl-2" v-if="item">
                        {{ item.name }}
                      </td>
                      <td v-if="item.batch && item">
                        {{ item.batch.name }}
                      </td>
                      <td colunmLeft v-if="item && item.unit">
                        {{ item.unit.name }}
                      </td>
                      <td style="text-align: center">{{ item.quantity }}</td>
                      <td style="text-align: center">{{ item.damage }}</td>
                      <td style="text-align: right">{{ item.unitPrice }}</td>
                      <td style="text-align: right">
                        {{ (item.unitPrice * item.quantity) | formatCurrency }}
                      </td>
                      <td style="text-align: right">
                        {{
                          item.discountAmount
                            ? item.discountAmount
                            : '0' | formatCurrency
                        }}
                      </td>
                      <td class="pr-2" style="text-align: right">
                        {{ item.amount | formatCurrency }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style="page-break-after: auto"></p>
                <br />

                <!-- Final Total -->
                <v-row style="page-break-inside: avoid">
                  <v-col cols="4" xl="4" md="4" lg="4">
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 20px;
                          padding-left: 15%;
                        "
                        >Total</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 30px;
                          padding-left: 15%;
                          color: #b91158;
                        "
                        >Rs.
                        {{
                          (SubTotal -
                            PurchaseDetails.discountAmount +
                            TotalAdditionalAmount)
                            | formatCurrency
                        }}</v-col
                      ></v-row
                    >
                  </v-col>
                  <!-- No of items -->
                  <v-col cols="4" xl="4" md="4" lg="4">
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 20px;
                          padding-left: 15%;
                        "
                        >No of Items</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 30px;
                          padding-left: 15%;
                          color: #b91158;
                        "
                        >{{ ProductData.length }}</v-col
                      ></v-row
                    >
                  </v-col>
                  <!-- Sub total -->
                  <v-col cols="2" xl="2" md="2" lg="2" style="font-size: 16px">
                    <v-row
                      ><v-col style="text-align: right"
                        >SubTotal :</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >Discount :</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >Additional :</v-col
                      ></v-row
                    >
                  </v-col>
                  <v-col cols="2" xl="2" md="2" lg="2" style="font-size: 16px">
                    <v-row
                      ><v-col style="text-align: right">{{
                        SubTotal | formatCurrency
                      }}</v-col></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >- {{ PurchaseDetails.discountAmount }}</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col style="text-align: right"
                        >+
                        {{
                          TotalAdditionalAmount
                            ? TotalAdditionalAmount
                            : '0' | formatCurrency
                        }}</v-col
                      ></v-row
                    >
                  </v-col>
                </v-row>
                <p style="page-break-after: auto"></p>
                <br />
                <!-- Payments Table -->
                <table class="table ag-cell" style="margin-top: -1%">
                  <thead>
                    <tr>
                      <th colspan="4" style="color: black">
                        <b>Payments</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="tablehead" style="font-weight: bold">
                      <td class="pl-5" style="text-align: left; width: 35%">
                        Date
                      </td>
                      <td style="text-align: left; width: 15%">Type</td>
                      <td style="text-align: right; width: 25%">Amount</td>
                      <td class="pr-5" style="text-align: right; width: 25%">
                        Status
                      </td>
                    </tr>
                    <tr v-for="(item, index) in PaymentDetails" :key="index">
                      <td class="pl-5" style="text-align: left; width: 35%">
                        {{
                          item.created_at
                            ? new Date(item.created_at).toLocaleString()
                            : '-----'
                        }}
                      </td>
                      <td style="text-align: left; width: 15%">
                        {{ item.payment_type ? item.payment_type : '---' }}
                      </td>
                      <td style="text-align: right; width: 25%">
                        {{ item.amount ? item.amount : '---' }}
                      </td>
                      <td class="pr-5" style="text-align: right; width: 25%">
                        {{ item.status ? item.status : '---' }}
                      </td>
                    </tr>
                    <tr v-if="PaymentDetails.length == 0">
                      <td colspan="4" style="text-align: center">
                        No Payments Available
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style="page-break-after: auto"></p>

                <!-- Prepared By, Date  -->
                <div style="page-break-inside: avoid">
                  <v-row>
                    <v-col
                      cols="6"
                      lg="6"
                      xl="6"
                      md="6"
                      style="margin-left: 3%; margin-top: 5%"
                    >
                      ---------------------------------- <br />
                      <p style="color: black; font-size: 13px">Prepared By</p>
                    </v-col>
                    <v-col
                      cols="5"
                      lg="5"
                      xl="5"
                      md="5"
                      style="margin-top: 5%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Date</p>
                    </v-col>
                  </v-row>
                  <!-- Authorized by -->
                  <v-row>
                    <v-col
                      cols="11"
                      lg="11"
                      xl="11"
                      md="11"
                      style="margin-left: 3%; margin-top: 2%; text-align: right"
                    >
                      ------------------------------<br />
                      <p style="color: black; font-size: 13px">Authorized By</p>
                    </v-col>
                  </v-row>
                </div>
                <!-- bottom component -->
                <div style="text-align: center; bottom: 10px; margin-top: 5%">
                  <p>&#169;www.speedcodelabs.com || &#9742; 0212211599</p>
                </div>
                <p style="page-break-after: always"></p>
              </div>
            </body>
          </div>
        </v-col>
        <!-- Print, mail , close component -->
        <v-col cols="3">
          <v-row>
            <v-col cols="12">
              <v-btn height="32" width="160" outline @click="openPrint">
                <v-icon class="icon_small mr-2" dark>print</v-icon>Print
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn height="32" width="160" outline disabled>
                <v-icon class="icon_small mr-2" dark>mail</v-icon> Mail
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                height="32"
                width="160"
                color="red"
                outline
                @click="closePreview"
              >
                <v-icon class="icon_small mr-2" style="color: white" dark
                  >close</v-icon
                ><span style="color: white"> Close </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      ReservationDetails: [],
      dialog: false,
      value: [],
      options: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['imagelink']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.PurchaseDetails);
        }
      },
    },
  },
  mounted() {
    this._keyListener = function (e) {
      if (e.key == 'Escape') {
        this.$emit('closePreview');
      }
    };

    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },
  props: {
    ProductData: {
      type: Array,
      default: [],
    },
    PaymentDetails: {
      type: Array,
      default: [],
    },
    PurchaseDetails: {
      type: Object,
      default: {},
    },
    WarehouseData: {
      type: Object,
      default: {},
    },
    Suppliers: {
      type: Object,
      default: {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    TotalAdditionalAmount: 0,
    SubTotal: 0,
    ProductDiscount: 0,
  },
  methods: {
    closePreview() {
      this.$emit('closePreview');
    },
    openPrint() {
      this.$htmlToPaper('receiptData');
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`;
      return date;
    },
    GetPurchaseStatusColor(status) {
      switch (status) {
        case 'Completed':
          return green;
          break;
        case 'Pending':
          return orange;
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
body {
  font-size: 16px;
}
table {
  margin: 40px 0px;
  font-size: 1rem;
  color: rgb(0, 0, 0);
  font-weight: 700;
  /* border: 1px solid rgb(0, 0, 0); */
  background-color: #fff;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;
}

.products th {
  /* border-bottom: 1px solid rgb(7, 7, 7) !important; */
  height: 60px;
  width: calc(100% / 9);
  vertical-align: middle !important;
}

table thead {
  background-color: rgb(0, 0, 0);
  font-size: 2rem;
  color: #fff;
  letter-spacing: 0.3rem;
}

.tablehead {
  font-weight: 900;
}

table tbody td:nth-child(6) {
  border-right: none;
}

table th {
  font-size: 16px;
}

table td,
table th {
  height: 50px;
}

tr {
  text-align: center;
}
.colunmLeft {
  text-align: left;
}

.columnRight {
  text-align: right;
}

.quaterWidth {
  width: 25%;
}
.example {
  background-color: #eee;
  width: 200px;
  height: 100px;
  border: 1px dotted black;
  overflow-y: scroll; /* Add the ability to scroll */
}

/* Hide scrollbar for Chrome, Safari and Opera */
.example::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.ag-cell {
  page-break-inside: avoid !important;
  overflow: hidden !important;
}
</style>
